/** Decode expiry only to shorten local retention. The server alone verifies JWT authorization. */
export function tokenExpiry(token: string | undefined): number {
  try {
    if (
      !token ||
      !/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(token)
    )
      return 0;
    const part = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const value: unknown = JSON.parse(atob(part));
    const exp =
      value && typeof value === 'object' && 'exp' in value
        ? value.exp
        : undefined;
    return typeof exp === 'number' && Number.isSafeInteger(exp) && exp > 0
      ? Math.min(Number.MAX_SAFE_INTEGER, exp * 1000)
      : 0;
  } catch {
    return 0;
  }
}
